import {extent} from 'd3-array';
import {isValid} from 'validators/number-validator';

export default (series, clampToZero) => {
  if (!series || !series.length) {
    return [0, 0];
  }

  // Flatten arrays
  const data = [].concat(...series.map((datum) => datum.data));

  // Get highest and lowest values
  const extents = extent(data, (datum) => {
    if (datum && isValid(datum.value)) {
      return datum.value;
    }
  });

  let max = isValid(extents[1]) ? extents[1] : 0;
  let min = isValid(extents[0]) ? extents[0] : 0;
  if (clampToZero && min > 0) {
    min = 0;
  }

  // Force-clamp to zero if both min and max are negative:
  if (min < 0 && max < 0) {
    max = 0;
  }

  return [min, max];
};
